import { Input, Component, Output, EventEmitter } from '@angular/core';
import { ContextDataService } from '../../core-services/Context.dataservice';
import { TranslationService } from '../../translations';
@Component({
    selector: 'tab',
    template: `
        <li
            class="tab"
            style="height:100%"
            [ngClass]="{
                activeTab: active,
                disableTab: disabled
            }"
            (click)="tabClicked($event)"
            tooltip
            [tooltipContent]="disabledTooltip || ''"
            [tooltipDisabled]="!disabled || !disabledTooltip"
            [tooltipAnimation]="true"
        >
            <span>
                <ng-content></ng-content>
            </span>
            @if (infoTooltip) {
                <i
                    style="margin-left: 3px;"
                    class="fa fa-info-circle"
                    tooltip
                    [tooltipContent]="infoTooltip"
                    [tooltipDisabled]="disabled"
                    [tooltipAnimation]="true"
                >
                </i>
            }
        </li>
    `,
    standalone: false
})
export class TabComponent {
    @Input()
    active = false;
    @Input()
    disabled = false;
    @Input()
    infoTooltip: string;
    @Input()
    disabledTooltip: string;
    @Output()
    readonly tabClick = new EventEmitter();

    static tooManyPeopleSelectedForTab(
        context: ContextDataService,
        maxRowsSelected = 20
    ): boolean {
        return context.resultSetPersonWithPatternCount > maxRowsSelected;
    }

    static getTabDisabledTooltipText(
        TR: TranslationService,
        context: ContextDataService,
        personWithPatternOnly = true
    ): string {
        let key = 'table-bulkActions.pleaseSelectItems';
        if (this.tooManyPeopleSelectedForTab(context)) {
            key = 'table-bulkActions.tooManyPeopleWithPatternsSelected';
        } else if (personWithPatternOnly) {
            key = 'table-bulkActions.pleaseSelectAPersonWithPattern';
        }
        return TR.key(key);
    }

    tabClicked(event: Event) {
        if (this.disabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        this.tabClick.emit(event);
    }
}
